module.exports = require('./lib/websocket');


//////////////////
// WEBPACK FOOTER
// ./~/web3-providers/~/websocket/index.js
// module id = 2648
// module chunks = 0 1